module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-grey-1-e87d1595a280871147de4d056d7d63ce.webp";